module.exports = __webpack_public_path__ + "img/the surface is so fun.e5a58199.png";